import { RE_ASSESSMENT_FILTER } from "../../../enums/ReAssessmentEnums";
import { parseListInput } from "../../../core/utils/parse-list-input";
import { STUDY_STATUS_OPTIONS, STUDY_TYPE_OPTIONS, yesNo } from "../../quick-filter/ExtraFilters";

/**
 * Rapor grid'inin "Diğer filtreler" alanları — çubukta kendi düğmesi olmayan, sol panelde (ReportFilter) duran
 * filtreler. Alan tanımının biçimi: bkz. quick-filter/ExtraFilters. Sıra paneldeki sıradır.
 */
export const REPORT_EXTRA_FIELDS = [
    { key: 'hospitalGroupIdList', label: 'Hospital Groups', kind: 'lookup', source: 'hospitalGroups', empty: [], permissions: ['HOSPITAL_GROUP_FILTER'] },
    { key: 'hospitalIdList', label: 'Hospital Name', kind: 'lookup', source: 'hospitals', empty: [] },
    { key: 'patientId', label: 'Patient Id', kind: 'text', empty: undefined },
    { key: 'patientName', label: 'Patient Name', kind: 'text', empty: undefined },
    { key: 'accessionNumber', label: 'Accession No', kind: 'text', empty: undefined },
    {
        key: 'studyIdList',
        label: 'Study ID',
        kind: 'list',
        empty: [],
        // Sol panel gibi: sayı olmayan değer atılır (bkz. ReportFilter.filter).
        toFilter: (value) => ({
            studyIdList: parseListInput(value).map(x => parseInt(x, 10)).filter(x => !isNaN(x)),
        }),
    },
    { key: 'studyInstanceUidList', label: 'Study UID', kind: 'list', empty: [] },
    { key: 'institutions', label: 'Institution', kind: 'lookup', source: 'institutions', empty: [], permissions: ['VIEW_STUDY_INSTITUTION'] },
    {
        // Kapsam SUNUCUDA belirlenir: RE_ASSESSMENT_MANAGE yoksa yalnız kullanıcının kendi okuduğu raporlar.
        key: 'reAssessmentState',
        label: (can) => (can('RE_ASSESSMENT_MANAGE') ? 'Re-Assessment' : 'My Re-Assessments'),
        kind: 'select',
        options: [
            { value: RE_ASSESSMENT_FILTER.CHANGED, label: 'Report Changed' },
            { value: RE_ASSESSMENT_FILTER.UNCHANGED, label: 'Report Unchanged' },
            { value: RE_ASSESSMENT_FILTER.ANY, label: 'Re-Assessed' },
        ],
        empty: undefined,
    },
    { key: 'readUserId', label: 'Read User', kind: 'user', source: 'readableUsers', userType: 'read', empty: undefined },
    { key: 'writeUserId', label: 'Wrote User', kind: 'user', source: 'writableUsers', userType: 'write', empty: undefined },
    { key: 'studyTypeList', label: 'Study Type', kind: 'select', multiple: true, options: STUDY_TYPE_OPTIONS, empty: [] },
    { key: 'studyStatus', label: 'Study Status', kind: 'select', multiple: true, options: STUDY_STATUS_OPTIONS, empty: [] },
    // Sol panel gibi yalnız "Bana atananlar" (kullanıcı listesinden seçim rapor panelinde yok).
    { key: 'assignDoctor', label: 'Assigned (Doctor)', kind: 'assign', empty: null, permissions: ['STUDY_SET_READ'] },
    { key: 'assignReporter', label: 'Assigned (Reporter)', kind: 'assign', empty: null, permissions: ['REPORT_ADD_OR_EDIT'] },
    { key: 'isDeleted', label: 'Is Deleted', kind: 'select', options: yesNo('Deleted', 'Not Deleted'), empty: false, permissions: ['STUDY_REQUEST_LIST_DELETED'] },
];
